import { FiInbox } from "react-icons/fi";

/**
 * Estado vazio padrão para tabelas/listas de relatório sem resultado.
 */
const EstadoVazio = ({ titulo = "Nenhum dado encontrado", descricao, icone: Icone = FiInbox }) => (
  <div className="text-center py-16">
    <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
      <Icone size={22} className="text-gray-400" />
    </div>
    <p className="text-gray-600 font-medium">{titulo}</p>
    {descricao && <p className="text-gray-400 text-sm mt-1">{descricao}</p>}
  </div>
);

export default EstadoVazio;
